// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-rZ6n","form":"styles_form__TtrmV","item":"styles_item__0BrE8","label":"styles_label__veDHp","inputNumber":"styles_inputNumber__zuZCm"};